import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { DateDiffCalc } from "../components/DateDiffCalc";
import { DdBreadcrumb } from "../components/DdBreadcrumb";
import { DdExplainer } from "../components/DdExplainer";

export function DateDifferencePage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <DdBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.dd_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.dd_intro()}
          </p>
        </header>

        <DateDiffCalc />

        <DdExplainer
          howTo={m.dd_howto()}
          faqs={[
            { q: m.dd_faq1_q(), a: m.dd_faq1_a() },
            { q: m.dd_faq2_q(), a: m.dd_faq2_a() },
            { q: m.dd_faq3_q(), a: m.dd_faq3_a() },
            { q: m.dd_faq4_q(), a: m.dd_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
